import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/monterey.jpg"

class Monterey extends Component {
  static displayName = "Monterey"
  static style = "form"
  static formats = ["modal"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "email_address",
      label: "Your email address"
    }
  ]

  render() {
    const { elements, styles, ...props } = this.props

    return (
      <Form
        {...props}
        style={styles.forElement("form", {
          backgroundColor: "#ffffff",
          borderRadius: 4
        })}
      >
        <div data-style="image">
          <div
            data-element="column"
            className="formkit-column"
            style={styles.forElement("content")}
          >
            <div
              style={styles.forElement("background")}
              className="formkit-background"
            />
            <Elements.Header
              tag="h2"
              name="header"
              defaults={{ content: "Join the newsletter" }}
            />
            <Elements.Content
              name="subheader"
              defaults={{
                content: "Subscribe to get our latest content by email."
              }}
            />
          </div>
          <div data-element="column" className="formkit-column">
            <Elements.Errors />

            <Elements.CustomFields>
              <Elements.AddFieldButton />
              <Elements.Button
                name="submit"
                group="button"
                defaults={{ content: "Subscribe" }}
              />
            </Elements.CustomFields>

            <Elements.BuiltWith background="form" />
          </div>
        </div>
      </Form>
    )
  }
}

Monterey.displayName = "Monterey"

export default Monterey
